import script from "./UsersInWorkspace.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersInWorkspace.vue?vue&type=script&lang=ts&setup=true"

import "./UsersInWorkspace.vue?vue&type=style&index=0&id=108bcd30&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-108bcd30"]])

export default __exports__